import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface SaveConflictDialogProps {
  open: boolean;
  onOverwrite: () => void;
  onCancel: () => void;
  conflictMessage?: string;
}

/**
 * Dialog to handle save conflicts when recipe has been modified by another user
 */
export const SaveConflictDialog: React.FC<SaveConflictDialogProps> = ({
  open,
  onOverwrite,
  onCancel,
  conflictMessage,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Save Conflict Detected</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {conflictMessage ||
            'This recipe has been modified by another user. Saving will overwrite their changes.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onOverwrite} variant="contained" color="warning">
          Overwrite Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
